import { useTranslation } from 'react-i18next';

export function AppFooter() {
  const { t } = useTranslation('common');
  const year = new Date().getFullYear();
  return (
    <footer className="text-muted-foreground border-t px-4 py-4 text-center text-xs">
      {t('footer', { year })}
    </footer>
  );
}
